<template>
    <div class="background">
        <el-space wrap direction="vertical" class="login">
            <el-card style="min-width: 400px;">
                <template #header>
                    <span>Photos</span>
                </template>
                <el-form
                    ref="ruleForm"
                    :model="ruleForm"
                    status-icon
                    :rules="rules"
                    label-width="120px"
                    class="demo-ruleForm"
                    @submit.prevent="submitForm('ruleForm')"
                    >
                    <el-form-item label="Mot de passe" prop="checkPass">
                        <el-input v-model="ruleForm.pass" show-password></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">Valider</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
            <el-card shadow="never" style="background-color: transparent;">
                <el-text type="info" size="small">Photo Front version {{ version }}</el-text>
                <br/>
                <el-text type="info" size="small">{{ server_version }}</el-text>
            </el-card>
        </el-space>
    </div>
</template>

<style>
.background {
    height: 100%;
    background-image: linear-gradient(to right top, #d8ece8, #deefef, #e5f3f5, #edf6f9, #f4f9fc, #f4f9fc, #f4f8fc, #f4f8fc, #edf4f9, #e6f0f6, #dfecf3, #d8e8f0);
}
.login {
    padding-top: 50px; 
    min-height: 100%;
}
</style>

<script>
import axios from "axios";

export default {
    props: {
        locationApi: String,
        version: String,
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Veuillez saisir le mot de passe'))
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('pass')
                }
                callback()
            }
        }
        return {
            ruleForm: {
                pass: '',
            },
            rules: {
                pass: [{ validator: validatePass, trigger: 'blur' }],
            },
            server_version: '?',
            front_version: '?',
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.login();
                } else {
                    return false
                }
            })
        },
        login() {
            axios
                .post(`${this.locationApi}/login`, {
                    password: this.ruleForm.pass,
                })
                .then(response => {
                    sessionStorage.token = response.data.token;
                    this.$emit('connect', response.data.token);
                    console.info(`Photos Server version ${response.data.version}`);
                })
                .catch(err => {
                    if (`${err}` == 'Error: Network Error') {
                        this.$message({ message: err, type: "error" });
                    } else {
                        this.$message({ message: "Mot de passe incorrect!", type: "warning" });
                    }
                });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
    },
    mounted() {
        if (sessionStorage.token) {
            this.$emit('connect', sessionStorage.token);
            return;
        }
        axios
            .get(`${this.locationApi}/`)
            .then(response => {
                if (response.data !== "photos") {
                    this.server_version = response.data;
                }
            })
            .catch(err => {
                this.$alert(`Service indisponnible (${err})`, "Oups!", {
                    type: "warning"
                });
            });
    },
}
</script>
